import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * This component is a collapsable block that displays an header with a title and uses the ng-content tag to display content inside the collapsable block
 * @Input title is the title of the block
 * @Input isCollapsable is the flag that sets if the pannel is collapsable or simply displays the content. is TRUE by default
 * @Input flag that controls if the panel is open or not. Can be from outside of this component if needed.
 */
@Component({
  selector: 'collapsable',
  templateUrl: './collapsable.component.html',
  styleUrls: ['./collapsable.component.scss'],
  standalone: false,
})
export class CollapsableComponent implements OnInit {
  @Output() openCloseCollapsableEmitter = new EventEmitter<void>();
  @Input() title: string;
  @Input() isCollapsable = true;
  @Input() isOpen = false;
  @Input() withBorder = false;
  @Input() searchMode: boolean;

  ngOnInit() {
    if (!this.isCollapsable) {
      this.isOpen = true;
    }
  }

  handleCollapsableClick(): void {
    this.openCloseCollapsableEmitter.emit();
  }

  handleHeaderKeydown(event: KeyboardEvent): void {
    const key = event.key;

    if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      this.handleCollapsableClick();
    }
  }
}
